import { useAtomValue } from 'jotai'

import {
  showValidationResultsAtom,
  validationResultsAtom
} from 'Automations/automationEditor/atoms'
import { HANDLE_VALIDATION_FIELD_PREFIX } from '../../constants'

type UseHandleHasError = (props: {
  nodeId: string
  handleId: string
}) => boolean

export const useHandleHasError: UseHandleHasError = ({ nodeId, handleId }) => {
  const validationResults = useAtomValue(validationResultsAtom)
  const showValidationResults = useAtomValue(showValidationResultsAtom)
  if (!showValidationResults) return false

  const resultsForNodeId = validationResults[nodeId]
  if (!resultsForNodeId) return false

  const handleFieldId = `${HANDLE_VALIDATION_FIELD_PREFIX}:${handleId}`
  return (resultsForNodeId[handleFieldId]?.length ?? 0) > 0
}
